// n8n Webhook Configuration
// DEBUG: Log environment variable loading
console.log('[gemini.js] Environment REACT_APP_N8N_WEBHOOK_URL:', process.env.REACT_APP_N8N_WEBHOOK_URL);

const N8N_WEBHOOK_URL = process.env.REACT_APP_N8N_WEBHOOK_URL || 'https://n8n.dleaf.net/webhook/ai-photo-booth-dubai';

console.log('[gemini.js] Using URL:', N8N_WEBHOOK_URL);
console.log('[gemini.js] Source:', process.env.REACT_APP_N8N_WEBHOOK_URL ? 'environment' : 'fallback');

const cleanBase64 = (base64Data) => {
  if (!base64Data) {
    console.error('[cleanBase64] ERROR: null/undefined data');
    return '';
  }
  const cleaned = base64Data.split(',')[1] || base64Data;
  console.log('[cleanBase64]', base64Data.length, '->', cleaned.length);
  return cleaned;
};

export const generateStyledImage = async (base64Image, stylePrompt) => {
  console.log('========== IMAGE GENERATION START ==========');
  console.log('[GEN] URL:', N8N_WEBHOOK_URL);
  console.log('[GEN] User photo:', base64Image ? 'present' : 'MISSING');
  console.log('[GEN] Prompt:', stylePrompt ? 'present' : 'MISSING');

  try {
    if (!base64Image) throw new Error('User photo required');
    if (!stylePrompt) throw new Error('Prompt required');

    console.log('[STEP 1] Building payload...');
    const payload = {
      userPhoto: cleanBase64(base64Image),
      stylePrompt: stylePrompt,
      timestamp: new Date().toISOString()
    };

    console.log('[STEP 2] Sending POST...');
    let response;
    try {
      response = await fetch(N8N_WEBHOOK_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      console.log('[STEP 2] Response:', response.status);
    } catch (fetchError) {
      console.error('[STEP 2] FAILED:', fetchError.message);
      throw fetchError;
    }

    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }

    console.log('[STEP 3] Parsing...');
    const result = await response.json();
    
    if (!result.generatedImage) {
      throw new Error('No image in response');
    }

    const generatedImage = result.generatedImage.startsWith('data:')
      ? result.generatedImage
      : 'data:image/jpeg;base64,' + result.generatedImage;

    console.log('========== GENERATION SUCCESS ==========');
    return generatedImage;

  } catch (error) {
    console.error('========== GENERATION FAILED ==========');
    console.error('[ERROR]:', error.message);

    if (error.message.includes('Failed to fetch') || error.name === 'TypeError') {
      throw new Error('Unable to connect to image generation service. This is likely a CORS issue. The n8n webhook needs to allow requests from your domain.');
    }
    throw new Error('Generation failed: ' + error.message);
  }
};

export const isGeminiConfigured = () => {
  return !!N8N_WEBHOOK_URL;
};
